var aoDiffuseOccPS = `
void occludeDiffuse() {
		dDiffuseLight *= dAo;
}
`;

export { aoDiffuseOccPS as default };
